var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ButtonBack',{staticClass:"mb_m"}),_c('input-name'),_c('input-place'),_c('input-date'),_c('input-start'),_c('input-finish'),_c('input-close-time'),_c('input-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }